import React from "react";
import { useMockAuth0 } from "../hooks/useMockAuth0";
import { LoadingState, UnauthenticatedState } from "../types";
import { AuthMappedProvider } from "./AuthMappedProvider";

interface MockAuthProviderProps {
  children: React.ReactNode;
  setAccessToken: (token: string) => void;
  setTokenProvider: (provider: () => Promise<string>) => void;
  fallback: (state: UnauthenticatedState | LoadingState) => React.ReactNode;
  onLogout?: () => void;
}

export function MockAuthProvider({
  children,
  fallback,
  setAccessToken,
  setTokenProvider,
  onLogout,
}: MockAuthProviderProps) {
  return (
    <AuthMappedProvider
      fallback={fallback}
      useAuth={useMockAuth0}
      setAccessToken={setAccessToken}
      setTokenProvider={setTokenProvider}
      onLogout={onLogout}
    >
      {children}
    </AuthMappedProvider>
  );
}
